<section>
  <form class="needs-validation" novalidate [formGroup]="formOrder">
    <div class="row p-2">
      <div class="col-lg-12 col-md-2 col-sm-4 col-6">
        <app-custom-select formControlName="conceptId" [required]="true" [labelText]="'Concepto'"
          [list]="listConcept"></app-custom-select>
      </div>
      <div class="col-lg-12 col-md-2 col-sm-4 col-6">
        <app-custom-textarea formControlName="observationAnnul" [required]="true" [labelText]="'Observación'"></app-custom-textarea>
      </div>
    </div>
  </form>
</section>
<section>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-3 gap-2">
      <app-custom-button [title]="'Anular'" [label]="'Anular'" [disabled]="disable"
        (onClick)="send()"></app-custom-button>
      <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'"
        (onClick)="close(false)"></app-custom-button>
    </div>
  </div>
</section>